// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IU6V","col":"styles_col__13JNb"};